import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Tab, } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import MyAccountForm from './MyAccountForm';
import BillingPayment from './BillingPayment';
import AccountSettings from './AccountSettings';
import AccountDialogs from '../nav/AccountDialogs';
const tabs = [
    { id: 'myAccount', text: 'My Account' },
    { id: 'profileSettings', text: 'Profile Settings' },
    { id: 'billingPayment', text: 'Memberships / Purchases' },
];
const MyAccount = ({ limitToPageWidth = true, }) => {
    const store = useStore();
    const [tabValue, setTabValue] = useState('myAccount');
    const { currentCustomer } = store;
    console.log('currentCustomer', currentCustomer);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    if (!currentCustomer) {
        return (_jsx(Box, { sx: { minHeight: 400 }, children: _jsx(AccountDialogs, { showDialog: "SIGN-IN", setShowDialog: () => { }, handleClose: () => { } }) }));
    }
    return (_jsx(Box, { sx: {
            m: 2,
            px: 2,
            ...(limitToPageWidth && {
                width: '100%',
                maxWidth: 1200,
                marginX: 'auto',
            }),
        }, children: _jsxs(TabContext, { value: tabValue, children: [_jsx(TabList, { onChange: handleTabChange, "aria-label": "tabs", textColor: "inherit", children: tabs.map((tab) => (_jsx(Tab, { value: tab.id, label: tab.text, sx: {
                            p: 0,
                            mx: 2,
                            my: 1.5,
                            minWidth: '50px',
                            minHeight: '25px',
                        } }, tab.id))) }), _jsxs(Box, { m: 2, children: [tabValue === 'myAccount' && _jsx(MyAccountForm, {}), tabValue === 'profileSettings' && _jsx(AccountSettings, {}), tabValue === 'billingPayment' && _jsx(BillingPayment, {})] })] }) }));
};
MyAccount.defaultProps = {};
MyAccount.meta = {
    group: 'account',
    name: 'My Account',
    description: 'Shows information about the current users account',
    props: [
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'MyAccount',
        props: {
            limitToPageWidth: true,
        },
    },
};
export default observer(MyAccount);
//# sourceMappingURL=MyAccount.js.map